var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pie"},[_c('canvas',{attrs:{"id":'myChart' + _vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }